import { Navigate, useLocation } from 'react-router-dom';

interface Props {
  from: string;
  to: string;
}

const CanonicalRouteRedirect = ({ from, to }: Props) => {
  const { pathname, search, hash } = useLocation();
  return <Navigate
    to={`${to}${pathname.slice(from.length)}${search}${hash}`}
    replace />;
};

export default CanonicalRouteRedirect;
